const products_on_page = document.getElementById('product-grid');
const nextUrl = document.getElementById('paginateNext');
let next_url = nextUrl && nextUrl.dataset ? nextUrl.dataset.nextUrl : '';

const load_more_btn = document.getElementsByClassName('load-more_btn')[0];
const load_more_spinner = document.getElementsByClassName('load-more_spinner')[0];

if (load_more_btn && !next_url) {
  // No next page available; keep button hidden if present
  load_more_btn.style.display = 'none';
}

async function getNextPage() {
  try {
    if (!next_url) return '';
    let res = await fetch(next_url);
    return await res.text();
  } catch (error) {
    console.log(error);
  }
}

async function loadMoreProducts() {
  if (!next_url) return;
  if (load_more_btn) load_more_btn.style.display = 'none';
  if (load_more_spinner) load_more_spinner.style.display = 'block';
 
  let nextPage = await getNextPage();
  const parser = new DOMParser();
  const nextPageDoc = parser.parseFromString(nextPage, 'text/html');
  if (load_more_spinner) load_more_spinner.style.display = 'none';
  const productgrid = nextPageDoc.getElementById('product-grid');
  if (!productgrid) return;
  
  // Convert to array to avoid live HTMLCollection issues
  const new_products = Array.from(productgrid.getElementsByClassName('grid__item'));
  
  const newPagination = nextPageDoc.getElementById('paginateNext');
  const new_url = newPagination ? newPagination.dataset.nextUrl : '';
  
  if (load_more_btn) {
    if (new_url) {
      load_more_btn.style.display = 'flex';
    } else {
      load_more_btn.style.display = 'none';
    }
  }
 
  next_url = new_url;
 
  // Now safe to append all products
  for (let i = 0; i < new_products.length; i++) {
    products_on_page.appendChild(new_products[i]);
  }
}
